import { Box, Collapse, Flex, Text, UnstyledButton } from '@mantine/core';
import { IconViewportShort, IconViewportTall } from '@tabler/icons-react';
import { useState } from 'react';
import { MarkdownView } from 'src/common/components/markdown-editor/MarkdownView';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  content: string;
};

export function ThinkingTile({ content }: Props) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box mb="md">
      <UnstyledButton
        onClick={() => setExpanded(!expanded)}
        py="xxxs"
        px="xxs"
        bg="orange.2"
        style={{ borderRadius: 24 }}
      >
        <Flex align="center" gap="xs">
          {expanded ? (
            <IconViewportShort size={16} color="var(--mantine-color-gray-8)" />
          ) : (
            <IconViewportTall size={16} color="var(--mantine-color-gray-8)" />
          )}
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.8">
            {expanded ? 'Hide thinking process' : 'View thinking process'}
          </Text>
        </Flex>
      </UnstyledButton>

      <Collapse expanded={expanded}>
        <Box fz="var(--mantine-font-size-textSm)" fw={FONT_WEIGHTS.medium} c="gray.6" mt="xs">
          <MarkdownView value={content} />
        </Box>
      </Collapse>
    </Box>
  );
}
